import { useScroll, useVelocity, useTransform, useSpring } from "framer-motion";

/**
 * Returns a smooth MotionValue<number> representing skewX degrees,
 * driven by the global scroll velocity.
 *
 * Positive scroll (down) → negative skew (elements lean forward).
 * The spring ensures a satisfying rubber-band return to 0.
 *
 * @param {number} maxDeg  Maximum skew in degrees (default 4).
 */
export default function useScrollVelocitySkew(maxDeg = 4) {
  const { scrollY } = useScroll();
  const velocity    = useVelocity(scrollY);

  const skew = useTransform(
    velocity,
    [-3000, 0, 3000],
    [maxDeg, 0, -maxDeg],
    { clamp: true },
  );

  return useSpring(skew, { stiffness: 400, damping: 50, mass: 0.3 });
}
